module.exports = __webpack_public_path__ + "static/media/gaizao-jianyerenminzhengfu.0cf17ea5.png";